import { useContext } from "react";
import SidebarItem from "../SidebarItem";
import {
  useAppStore,
  useAppStoreMenuLinks,
} from "../../../apis/appStore.hooks";
import { AppContext } from "../../../context/app";
import CommittedClubSidebarItem from "../CommittedClubSidebarItem";

export const AppsSidebar = () => {
  const { client } = useContext(AppContext);
  const clientId = client?.uuid || client?.client_uuid;
  const { data: apps = [], isLoading } = useAppStore();
  const { data: menuLinks = [], isLoading: isLoadingMenuLinks } =
    useAppStoreMenuLinks(apps, clientId, {
      enabled: apps.length > 0,
    });

  if (isLoading || isLoadingMenuLinks) return null;

  return (
    <>
      <SidebarItem name="App Store" path="/app-store" reactPage />
      {menuLinks.map((link, key) => {
        if (link.slug === "/committed-club") {
          return (
            <CommittedClubSidebarItem
              key={key}
              name={link.name}
              path={link.slug}
              target={link.target}
            />
          );
        }

        return (
          <SidebarItem
            key={key}
            name={link.name}
            path={link.dashboardLink ? `/app/${link.slug}` : link.slug}
            target={link.target}
            reactPage={link.isReact}
          />
        );
      })}
    </>
  );
};
